/**
 * A journey scenario, named in the reader's language.
 *
 * The billing dialogs built it in English by splitting the enum value
 * ("pre_immigration" → "Pre Immigration"). The names already live in the
 * catalogue as `journey.details.scenario_<value>`; this maps each value to its
 * LITERAL key, so the key-usage gate checks every one, and the mapped type
 * fails the build when a scenario is added without a name. (L6 round 3)
 */
import type { JourneyScenario } from '@tonnie/types';

type Translate = (key: string) => string;

const SCENARIO_LABEL: { readonly [S in JourneyScenario]: (t: Translate) => string } = {
  pre_immigration: (t) => t('journey.details.scenario_pre_immigration'),
  already_abroad: (t) => t('journey.details.scenario_already_abroad'),
  relocation_only: (t) => t('journey.details.scenario_relocation_only'),
  integration_only: (t) => t('journey.details.scenario_integration_only'),
};

function isJourneyScenario(value: string): value is JourneyScenario {
  return Object.prototype.hasOwnProperty.call(SCENARIO_LABEL, value);
}

/** The scenario's name, or `null` for an absent or unknown value. */
export function journeyScenarioLabel(
  scenario: string | null | undefined,
  t: Translate
): string | null {
  return scenario && isJourneyScenario(scenario) ? SCENARIO_LABEL[scenario](t) : null;
}
